import type { Field } from '@sevenrooms/form'
import { useLocales } from '@sevenrooms/locales'
import { FormInput, Label } from '@sevenrooms/ui-kit/form'
import { reservationWidgetMessages } from '../../reservationWidgetMessages'

export interface PostalCodeFormProps {
  disabled: boolean
  postalCodeField: Field<string>
  required: boolean
}

export function PostalCodeForm({ disabled, postalCodeField, required }: PostalCodeFormProps) {
  const { formatMessage } = useLocales()

  const postalCodeMessage = formatMessage(reservationWidgetMessages.resWidgetPostalCodeLabel)

  return (
    <Label primary={`${postalCodeMessage}${required ? '*' : ''}`}>
      <FormInput
        aria-required="false"
        autoComplete="postal-code"
        data-test="sr-reservation-postal-code"
        disabled={disabled}
        field={postalCodeField}
        inputMode="text"
        placeholder={postalCodeMessage}
        type="text"
        fullWidth
      />
    </Label>
  )
}
